import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: '', name: 'Home', component: () => import('@/views/Home.vue'), meta: { title: '首页-竞迈广告设计制作' } },
      { path: 'about', name: 'About', component: () => import('@/views/About.vue'), meta: { title: '关于竞迈-竞迈广告设计制作' } },
      { path: 'news', name: 'NewsList', component: () => import('@/views/NewsList.vue'), meta: { title: '竞迈资讯-竞迈广告设计制作' } },
      { path: 'news/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail.vue'), meta: { title: '资讯详情-竞迈广告设计制作' } },
      { path: 'product', name: 'ProductList', component: () => import('@/views/ProductList.vue'), meta: { title: '产品中心-竞迈广告设计制作' } },
      { path: 'product/:id', name: 'ProductDetail', component: () => import('@/views/ProductDetail.vue'), meta: { title: '产品详情-竞迈广告设计制作' } },
      { path: 'product-detail/:id', name: 'ProductDetailNew', component: () => import('@/views/ProductDetailNew.vue'), meta: { title: '产品详情-竞迈广告设计制作' } },
      { path: 'contact', name: 'Contact', component: () => import('@/views/Contact.vue'), meta: { title: '联系我们-竞迈广告设计制作' } },
      { path: 'feedback', name: 'Feedback', component: () => import('@/views/Feedback.vue'), meta: { title: '留言反馈-竞迈广告设计制作' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
